<template>
  <main class="w-full flex-grow p-6">
    <!-- <h1 class="text-3xl text-black pb-6">Blank Page</h1> -->
    <button
      @click="showModalSosmed"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Sosmed
    </button>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="">
          <tr class="bg-gray-600">
            <th class="px-5" style="">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Link</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Image</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Options</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.sosmed_name }}
              </span>
            </td>
            <td class="text-center">
              <span>
                {{ sos.sosmed_link }}
              </span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img class="w-10 h-10" :src="sos.sosmed_image" alt="23paskal" />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button
                  class="mr-2"
                  type="button"
                  @click="showModalUpdate(sos)"
                >
                  <fas icon="pencil-alt" class="text-app-default text-xl" />
                </button>
                <button
                  class="mr-2"
                  type="button"
                  @click="showModalUpdateImage(sos.id)"
                >
                  <fas icon="file-signature" class="text-green-500 text-xl" />
                </button>
                <button
                  class="mr-2"
                  type="button"
                  @click="showModalDestroy(sos.id)"
                >
                  <fas icon="trash-alt" class="text-red-600 text-xl" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modal create -->
    <div
      v-if="modalSosmed"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">{{ title }}</div>
            <div class="">
              <button
                @click.self="closeModalSosmed"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Sosmed Name</label
                >
                <input
                  v-model="sosmed_name"
                  @keyup="sosmednameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.sosmed_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.sosmed_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Sosmed Link</label
                >
                <input
                  v-model="sosmed_link"
                  @keyup="sosmedLinkChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.sosmed_link
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Sosmed Link"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.sosmed_link_msg }}
                </div>
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Image (150 px X 150 px)</label
            >
            <div class="w-52">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                :class="[
                  errors.medsos_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewSingleImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  multiple="multiple"
                  @change="previewSingleImage"
                  id="single_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div v-if="preview" class="mr-1 relative rounded-lg w-full">
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeSingleFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img :src="preview" class="w-full h-52 rounded-lg" />
                  </div>
                  <div
                    v-if="preview === null"
                    v-cloak
                    @click="chooseSingleFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.medsos_image_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalSosmed"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="saveSosmed"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalSosmed"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update content -->
    <div
      v-if="modalUpdate"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 700px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Update Social Media</div>
            <div class="">
              <button
                @click.self="closeModalUpdate"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Sosmed Name</label
                >
                <input
                  v-model="sosmed_name"
                  @keyup="sosmednameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.sosmed_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.sosmed_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Sosmed Link</label
                >
                <input
                  v-model="sosmed_link"
                  @keyup="sosmedLinkChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.sosmed_link
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Sosmed Link"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.sosmed_link_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalUpdate"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateContentSosmed"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalUpdate"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update image -->
    <div
      v-if="modalUpdateImage"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Social Media Image (150 px X 150 px)
            </div>
            <div class="">
              <button
                @click.self="closeModalUpdateImage"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.medsos_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewSingleImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  multiple="multiple"
                  @change="previewSingleImage"
                  id="single_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div v-if="preview" class="mr-1 relative rounded-lg w-full">
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeSingleFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img :src="preview" class="w-full h-52 rounded-lg" />
                  </div>
                  <div
                    v-if="preview === null"
                    v-cloak
                    @click="chooseSingleFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.medsos_image_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalUpdateImage"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateSosmedImage"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalUpdateImage"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Warning !</div>
            <div class="">
              <button
                @click.self="closeModalDestroy"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            Are You Sure To Continue Delete This Social Media
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="destroyMediaSocial"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Table",
  components: { Warning, SuccessNotif },
  data() {
    return {
      modalDestroy: false,
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      modalSosmed: false,
      modalUpdate: false,
      modalUpdateImage: false,
      errors: {
        medsos_image: false,
        medsos_image_msg: "",
        sosmed_name: false,
        sosmed_name_msg: "",
        sosmed_link: false,
        sosmed_link_msg: "",
      },
      title: "",
      actionType: null,
      sosmed_name: "",
      sosmed_link: "",
      rows: [],
      id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    sosmedLinkChange: function(e) {
      this.sosmed_link = e.target.value;
      this.errors.sosmed_link = false;
      this.errors.sosmed_link_msg = "";
    },
    sosmednameChange: function(e) {
      this.sosmed_name = e.target.value;
      this.errors.sosmed_name = false;
      this.errors.sosmed_name_msg = "";
    },
    showModalDestroy: function(id) {
      this.id = id;
      this.modalDestroy = true;
    },
    closeModalDestroy: function() {
      this.id = null;
      this.modalDestroy = false;
    },
    chooseSingleFile: function() {
      document.getElementById("single_file").click();
    },
    removeSingleFile: function() {
      this.preview = null;
      this.image = null;
    },
    previewSingleImage: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.medsos_image = false;
      this.errors.medsos_image_msg = "";
    },
    showModalSosmed: function() {
      this.title = "Create New Sosmed";
      this.preview = null;
      this.image = null;
      this.sosmed_name = "";
      this.sosmed_link = "";
      this.modalSosmed = true;
    },
    closeModalSosmed: function() {
      this.modalSosmed = false;
    },
    showModalUpdate: function(val) {
      this.id = val.id;
      this.sosmed_name = val.sosmed_name;
      this.sosmed_link = val.sosmed_link;
      this.modalUpdate = true;
    },
    closeModalUpdate: function() {
      this.id = null;
      this.modalUpdate = false;
    },
    showModalUpdateImage: function(id) {
      this.id = id;
      this.preview = null;
      this.image = null;
      this.modalUpdateImage = true;
    },
    closeModalUpdateImage: function() {
      this.id = null;
      this.modalUpdateImage = false;
    },
    findMediaSocial: async function() {
      try {
        let res = await fetch(`${API}v1/media-social`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data;
        this.totalRecordCount = respon.data.length;
      } catch (err) {
        this._error("internal server error");
      }
    },
    saveSosmed: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("medsos_image", this.image);
      formdata.append("sosmed_name", this.sosmed_name);
      formdata.append("sosmed_link", this.sosmed_link);
      try {
        let res = await fetch(`${API}v1/admin/cms/sosmed/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "medsos_image") {
                this.errors.medsos_image = true;
                this.errors.medsos_image_msg = item.message;
              }
              if (item.key === "sosmed_name") {
                this.errors.sosmed_name = true;
                this.errors.sosmed_name_msg = item.message;
              }
              if (item.key === "sosmed_link") {
                this.errors.sosmed_link = true;
                this.errors.sosmed_link_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalSosmed = false;
        this.saveButton = "Save";
        this.findMediaSocial();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateSosmedImage: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("medsos_image", this.image);
      formdata.append("id", this.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/sosmed/update-image`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "medsos_image") {
                this.errors.medsos_image = true;
                this.errors.medsos_image_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalUpdateImage = false;
        this.saveButton = "Save";
        this.findMediaSocial();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateContentSosmed: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/sosmed/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
            sosmed_name: this.sosmed_name,
            sosmed_link: this.sosmed_link,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "sosmed_name") {
                this.errors.sosmed_name = true;
                this.errors.sosmed_name_msg = item.message;
              }
              if (item.key === "sosmed_link") {
                this.errors.sosmed_link = true;
                this.errors.sosmed_link_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalUpdate = false;
        this.findMediaSocial();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    destroyMediaSocial: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/sosmed/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          this._error("internal server error");
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.findMediaSocial();
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findMediaSocial();
  },
};
</script>
